/** Why an import failed; mapped to user-facing messages in `strings.ts`. */
export type ImportErrorCode =
  /** File or decompressed payload exceeds a size limit. */
  | 'too-large'
  /** Not a PNG or JSON file. */
  | 'unsupported-file'
  /** A PNG without embedded Kinklist data. */
  | 'no-data'
  /** Data present but damaged (bad base64, deflate, UTF-8, JSON, PNG structure…). */
  | 'corrupt'
  /** Well-formed data that isn't a valid Kinklist (failed schema validation). */
  | 'invalid'
  /** The remote image no longer exists. */
  | 'not-found'
  /** The network request failed. */
  | 'network';

export class ImportError extends Error {
  readonly code: ImportErrorCode;

  constructor(code: ImportErrorCode, message?: string, options?: ErrorOptions) {
    super(message ?? code, options);
    this.name = 'ImportError';
    this.code = code;
  }
}
